class Head {
  defaultHead() {
    return {
      title: 'WPS学堂',
      meta: [
        {
          name: 'keywords',
          content:
            'WPS学堂,Word,Excel,PPT,PDf,word文档,表格,幻灯片,Excel函数,PPT技巧,word转pdf,word/ppt排版,页眉页脚,目录,打印',
        },
        {
          name: 'description',
          content:
            'WPS学堂是WPS官方技巧教程学习平台,包含WPS教程,Office教程,Word文字处理教程技巧,' +
            'Excel表格函数功能图表, PPT演示幻灯片制作操作技巧, word转pdf, word/ ppt排版, 页眉页脚, 目录, 打印, 数据透视, 段落设置, 表格图表, 学习wpsoffice软件, 就来wps自习室！',
        },
      ],
    };
  }
  searchHead(keywords) {
    const headers = {};
    const headTitle = `${keywords}-WPS学堂`;
    const headKeywords = `${keywords},WPS学堂,WPS,Word,Excel,PPT,文字,表格,演示,Word学习,Excel学习,PPT学习,办公技巧学习,办公软件,办公技能 如何恢复未保存文件`;
    const headDescription = `${keywords},WPS学堂是WPS官方免费学习网站，WPS办公软件使用教程，Office使用教程。Word文字、Excel表格、PPT演示的操作技巧学习。`;

    headers['title'] = headTitle;
    headers['meta'] = [
      {
        name: 'keywords',
        content: headKeywords,
      },
      {
        name: 'description',
        content: headDescription,
      },
    ];
    return headers;
  }
  libraryHead() {
    return {
      title: 'Office图书馆-WPS学堂-WPS官方Office技巧学习平台',
      meta: [
        {
          name: 'keywords',
          content:
            'WPS学堂,Word,Excel,PPT,PDf,word文档,表格,幻灯片,Excel函数,PPT技巧,word转pdf,word/ppt排版,页眉页脚,目录,打印',
        },
        {
          name: 'description',
          content:
            'wps教程技巧是WPS官方技巧教程,包含WPS教程,Office教程,Word文字处理教程技巧,Excel表格函数功能图表,PPT演示幻灯片制作操作技巧,word转pdf,word/ppt排版,页眉页脚,目录,打印,数据透视,段落设置,表格图表,学习wpsoffice软件,就来wps学堂！',
        },
      ],
    };
  }
  libraryListHead(title) {
    return {
      title: `${title}-WPS学堂-WPS官方Office技巧学习平台`,
      meta: [
        {
          name: 'keywords',
          content:
            'WPS学堂,Word,Excel,PPT,PDf,word文档,表格,幻灯片,Excel函数,PPT技巧,word转pdf,word/ppt排版,页眉页脚,目录,打印',
        },
        {
          name: 'description',
          content:
            'wps教程技巧是WPS官方技巧教程,包含WPS教程,Office教程,Word文字处理教程技巧,Excel表格函数功能图表,PPT演示幻灯片制作操作技巧,word转pdf,word/ppt排版,页眉页脚,目录,打印,数据透视,段落设置,表格图表,学习wpsoffice软件,就来wps学堂！',
        },
      ],
    };
  }
  detailHead({ title, keywords, description }) {
    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: keywords,
        },
        {
          name: 'description',
          content: description,
        },
      ],
    };
  }
}

export default new Head();
